import { useRegisterEvents, useSigma } from "@react-sigma/core";
import { FC, PropsWithChildren, useEffect } from "react";

function getMouseLayer() {
  return document.querySelector(".sigma-mouse");
}

const GraphEventsController: FC<
  PropsWithChildren<{
    setHoveredNode: (node: string | null) => void;
    setClickedNode: (node: string | null) => void;
    clickedNode: string | null;
  }>
> = ({ setHoveredNode, setClickedNode, clickedNode, children }) => {
  const sigma = useSigma();
  const graph = sigma.getGraph();
  const registerEvents = useRegisterEvents();

  /**
   * Initialize here settings that require to know the graph and/or the sigma
   * instance:
   */
  useEffect(() => {
    registerEvents({
      clickNode({ node }) {
        if (!graph.getNodeAttribute(node, "hidden")) {
          // Toggle clicked node - if clicking same node, clear it
          setClickedNode(node === clickedNode ? null : node);
        }
      },
      clickStage() {
        // Clear clicked node when clicking on empty space
        setClickedNode(null);
      },
      enterNode({ node }) {
        if (!clickedNode) {
          // Only show hover effects if no node is clicked
          setHoveredNode(node);
          const mouseLayer = getMouseLayer();
          if (mouseLayer) mouseLayer.classList.add("mouse-pointer");
        }
      },
      leaveNode() {
        if (!clickedNode) {
          // Only clear hover if no node is clicked
          setHoveredNode(null);
          const mouseLayer = getMouseLayer();
          if (mouseLayer) mouseLayer.classList.remove("mouse-pointer");
        }
      },
    });
  }, [clickedNode]); // Add clickedNode to dependencies

  return <>{children}</>;
};

export default GraphEventsController;
